import React from "react";
import Status from "../../../model2/status/status";

type Props = {
    status              : Status
    className?          : string
    disabled?           : boolean

    onClick             : callback
    onClickDisabled?    : callback
    onMouseEnter?       : callback
    onMouseLeave?       : callback

}

export default function PopoverMenuOptionStatus(props:Props) {

    const classes = Classes('option', props.className, {
        'disabled'  : props.status.disabled,
        // 'disabled'  : props.disabled,
        // 'selected': props.selected
    });

    const onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation();

        if (props.status.disabled) {
            props.onClickDisabled && props.onClickDisabled();
            return
        }

        props.onClick(props.status.id)
    };

    const onMouseEnter = ()=>{
        if(props.onMouseEnter){
            props.onMouseEnter(props.status.description)
        }
    }

    // const labelClass = 'label ui5-txt-status-name gd-scf-'+props.status.color;

    const labelClass = Classes('label ui5-txt-status-name',{
        ['gd-scf-'+props.status.color]  : !props.status.disabled,
        ['gd-status-color-disabled-'+props.status.color]  : props.status.disabled,
    });

    return (
        <div className      =   {classes}
             onClick        =   {onClick}
             onMouseEnter   =   {onMouseEnter}
             onMouseLeave   =   {props.onMouseLeave}>

            <div className={labelClass}>
                {props.status.name}
            </div>

        </div>
    );
}

